import React from 'react';
// import { CalendarContainer, WelcomeMessageModalContainer,WelcomeMessageContainer } from 'containers';
import { CalendarContainer } from 'containers';

function DashboardPage() {
  return (
    <>
      <div className="d-flex w-100">
        <CalendarContainer />
      </div>
      {/* Keep these bcz client might be able to ask to restore  */}
      {/* <WelcomeMessageContainer /> */}
      {/* <WelcomeMessageModalContainer/> */}
    </>
  );
}

DashboardPage.propTypes = {};

export default DashboardPage;
